const MProduction = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'prd.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  }
]

// const MPRDPurchaseOrders = [
//   {
//     title: 'Purchase Orders',
//     is_heading: true,
//     is_active: false,
//     link: {
//       name: 'prd.purchase-orders'
//     },
//     class_name: 'mt-3 font-weight-bolder'
//   },
//   {
//     title: 'Requests',
//     is_heading: false,
//     is_active: false,
//     link: {
//       name: 'prd.purchase-orders.requests'
//     },
//     class_name: '',
//     is_icon_class: true,
//     icon: 'fat fa-cart-circle-plus',
//     active_icon: 'fad fa-cart-circle-plus'
//   },
//   {
//     title: 'Approvals',
//     is_heading: false,
//     is_active: false,
//     link: {
//       name: 'prd.purchase-orders.approvals'
//     },
//     class_name: '',
//     is_icon_class: true,
//     icon: 'fat fa-cart-circle-check',
//     active_icon: 'fad fa-cart-circle-check'
//   },
//   {
//     title: 'Posting',
//     is_heading: false,
//     is_active: false,
//     link: {
//       name: 'prd.purchase-orders.posting'
//     },
//     class_name: '',
//     is_icon_class: true,
//     icon: 'fat fa-code-compare',
//     active_icon: 'fad fa-code-compare'
//   },
//   {
//     title: 'Receiving',
//     is_heading: false,
//     is_active: false,
//     link: {
//       name: 'prd.purchase-orders.receiving'
//     },
//     class_name: '',
//     is_icon_class: true,
//     icon: 'fat fa-cart-circle-arrow-down',
//     active_icon: 'fad fa-cart-circle-arrow-down'
//   }
// ]

const MPRDAuthorityToWithdraws = [
  {
    title: 'ATWs',
    is_heading: true,
    is_active: false,
    link: {
      name: 'prd.atws'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Receiving',
    is_heading: false,
    is_active: false,
    link: {
      name: 'prd.atws.receiving'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-down',
    active_icon: 'fad fa-cart-circle-arrow-down'
  }
]

const MPRDInterWarehouses = [
  {
    title: 'Inter Warehouses',
    is_heading: true,
    is_active: false,
    link: {
      name: 'prd.inter-warehouses'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Transfers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'prd.inter-warehouses.transfers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-up',
    active_icon: 'fad fa-cart-circle-arrow-up'
  },
  {
    title: 'Posting',
    is_heading: false,
    is_active: false,
    link: {
      name: 'prd.inter-warehouses.posting'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-code-compare',
    active_icon: 'fad fa-code-compare'
  },
  {
    title: 'Receiving',
    is_heading: false,
    is_active: false,
    link: {
      name: 'prd.inter-warehouses.receiving'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-down',
    active_icon: 'fad fa-cart-circle-arrow-down'
  }
]

export default MProduction.concat(
  // MPRDPurchaseOrders,
  MPRDAuthorityToWithdraws,
  MPRDInterWarehouses
)
